import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs-compat';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class ArchiveService {
	constructor(private http: HttpClient) {}

	getArchive(type: string): Observable<any> {
		const url = `${environment.api}archive/get_archived?type=${type}`;
		return this.http.get(url);
	}

	getArchiveByDate(type: string, start: string, end: string) {
		const url = `${environment.api}archive/get_archived_by_date?type=${type}&start_date=${start}&end_date=${end}`;
		return this.http.get(url);
	}

	restoreRecord(type: string, id: number) {
		const url = `${environment.api}archive/restore`;
		return this.http.post(url, { type, id });
	}
}
